(function () {
    'use strict';

    angular
        .module('sod.helper')
        .directive('dropdownSelect', dropdownSelect);

    const template = '<div class="dropdown-select-wrapper" id="<%elementId%>">' +
        '<div class="dropdown-select-selector" ng-click="showDropdown()"><span  ng-bind-html="current"></span><i class="fa fa-caret-down selector-icon"></i></div>' +
        '<div class="dropdown-select-options-wrapper">' +
        '<ul class="dropdown-select-options" ng-style="selectOptionsStyle" ng-class="{active: dropdownActive}"><li class="dropdown-select-item" ng-repeat="option in options" ng-bind-html="option.label" ng-click="select(option)"></li></ul>' +
        '</div>' +
        '</div>';

    function dropdownSelect(lodash, $document) {
        return {
            restrict: 'E',
            require: 'ngModel',
            template: template,
            scope: {
                options: '='
            },
            link: function(scope, elem, attr, ctrl) {
                scope.dropdownActive = false;
                scope.elementId = scope.$id;
                scope.selectOptionsStyle = {};
                var optionsElem = elem.find('.dropdown-select-options');
                ctrl.$render = function() {
                    const selected = lodash.find(scope.options, { value: ctrl.$viewValue });
                    scope.current = selected.label;
                };

                scope.select = function(option) {
                    ctrl.$setViewValue(option.value);
                    scope.current = option.label;
                    scope.dropdownActive = false;
                };
                ctrl.$formatters.push(function(modelValue) {
                   return modelValue;
                });
                ctrl.$parsers.push(function(viewValue) {
                   return viewValue;
                });

                scope.showDropdown = function() {
                    scope.dropdownActive = true;
                    scope.selectOptionsStyle.height = optionsElem.height();

                };

                $document.on('click', function (e) {
                    e.stopPropagation();
                    if (angular.element(e.target).parents('.dropdown-select-wrapper').length === 0) {
                        scope.dropdownActive = false;
                        scope.$apply();
                        return;
                    }
                    if (angular.element(e.target).parents('.dropdown-select-wrapper').attr('id') !== scope.elementId.toString()) {
                        scope.dropdownActive = false;
                        scope.$apply();
                    }
                });
            }
        };
    }
})();